import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { errorToast, success } from "../../utils/helpers.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import {
  useAddCheckInMutation,
  useAddCheckOutMutation,
} from "../../Redux/services/ClientAPis/staffAttendance.js";

const AddAttendance = ({ setIsOpen, refetch }) => {
  const dispatch = useDispatch();
  const [attendanceAction, setAttendanceAction] = useState("checkin");
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [addCheckIn, { isLoading: checkInLoading }] = useAddCheckInMutation();
  const [addCheckOut, { isLoading: checkOutLoading }] =
    useAddCheckOutMutation();

  const handleActionToggle = (action) => {
    setAttendanceAction(action);
  };

  const onSubmit = async (data) => {
    const payload = { ...data };
    let response;

    try {
      if (attendanceAction === "checkin") {
        response = await addCheckIn(payload);
      } else {
        response = await addCheckOut(payload);
      }

      if (response?.data?.code === 200) {
        success(response?.data?.message || "Attendance Updated Successfully");
        setIsOpen(false);
        refetch();
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  return (
    <div className="edit-profile-content">
        <div className="d-flex gap-3 mt-3 w-100 justify-content-end mb-4">
        <Button
          className="w-25 theme-btn"
          onClick={() => handleActionToggle("checkin")}
          disabled={attendanceAction === "checkin"}
        >
          Check-in
        </Button>
        <Button
          className="w-25 theme-btn"
          onClick={() => handleActionToggle("checkout")}
          disabled={attendanceAction === "checkout"}
        >
          Check-out
        </Button>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        {/* Attendance Date */}
        <ThemeInput
          name="attendance_date"
          errors={errors}
          control={control}
          type="date"
          className="mt-2"
          placeholder="Attendance Date"
          rules={{ required: "Attendance date is required" }}
        />

        {/* Check-in or Check-out Time */}
        <ThemeInput
          name={attendanceAction === "checkin" ? "checkin_at" : "checkout_at"}
          errors={errors}
          control={control}
          type="time"
          className="mt-3"
          placeholder={
            attendanceAction === "checkin" ? "Check-in Time" : "Check-out Time"
          }
          rules={{
            required: `${
              attendanceAction === "checkin" ? "Check-in" : "Check-out"
            } time is required`,
          }}
        />

        <div className="d-flex gap-3 mt-4">
          <div className="btn-submit w-50">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-50">
            <Button
              disabled={checkInLoading || checkOutLoading}
              type="submit"
              className="theme-btn w-100"
            >
              {checkInLoading || checkOutLoading ? (
                <ThemeSpinner />
              ) : attendanceAction === "checkin" ? (
                "Check-in"
              ) : (
                "Check-out"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddAttendance;
